export const SIGN_IN = '/sign-in';
export const SIGN_UP = '/sign-up';
export const FORGOT_PASSWORD = '/forgot-password';
export const SET_PASSWORD = '/set-password/:uuid/:access/:refresh';
export const VERIFY_EMAIL = '/verify-email';
export const INVITATION = '/invite/:token';

export type HomeType = 'businesses' | 'sponsor-community' | 'settings';
export const HomeRoutes = ['businesses', 'sponsor-community', 'settings'];
export const HOME = '/:type';
export const BUSINESSES = 'businesses';
export const SETTINGS = 'settings';
export const SPONSOR_COMMUNITY = 'sponsor-community';

export const COMMUNITY = '/city/:uploadState';
export const NO_BUSINESS = '/no-association';
export const CHOOSE_BUSINESS = '/choose-business';

export const MY_PROFILE = '/me';
export const BUSINESS_PROFILE = '/profile';

export const RESEND_INVITE = '/resend-invite';

export const BUSINESS_ONBOARDING = '/business-onboarding';
